module.exports = __webpack_public_path__ + "static/media/visa-2.af62554d.png";